import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

import Axios from 'axios';
//Import FastClick
import FastClick from 'fastclick';

FastClick.attach(document.body);
// Import Loading and stylesheet
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/images/error.png'),
  loading:require('./assets/images/Loading.png'),
  attempt: 1
})
import VueLazyload from 'vue-lazyload'
import VueClipboard from 'vue-clipboard2'



Vue.use(Loading);
Vue.use(VueClipboard)
//Import Toast
import { Toast, Dialog, List,ImagePreview } from 'vant';
Vue.use(Toast);
Vue.use(List);
Vue.use(Dialog);
Vue.use(ImagePreview)

import layer from 'vue-layer';
import 'vue-layer/lib/vue-layer.css';
Vue.prototype.$layer = layer(Vue);
Vue.prototype.$layer = layer(Vue, {
  msgtime: 3 //目前只有一项，即msg方法的默认消失时间，单位：秒
});



if (process.env.NODE_ENV == 'development') {
  Axios.defaults.baseURL = '/api';
} else {
  Axios.defaults.baseURL = '/interface/';
}

Axios.defaults.headers = {
  'Content-Type': 'application/json'
};

Vue.config.productionTip = false;
let user_str = localStorage.getItem('userInfo');
if (user_str) {
  let user = JSON.parse(user_str);
  store.commit('setUserInfo', user);
  store.commit('setLogin', true);
  Axios.defaults.headers.AuthUserId = user.uid;
}
Vue.prototype.axios = Axios;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
